'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListEditor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _utilsList = require('@bibliocommons/utils-list');

var _editorToolbar = require('../../editor-toolbar');

var _editorToolbar2 = _interopRequireDefault(_editorToolbar);

var _editorBody = require('../../editor-body');

var _editorBody2 = _interopRequireDefault(_editorBody);

var _editorHeader = require('../../editor-header');

var _editorHeader2 = _interopRequireDefault(_editorHeader);

require('../styles/ListEditor.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListEditor = exports.ListEditor = function (_BcReactComponent) {
  _inherits(ListEditor, _BcReactComponent);

  function ListEditor(props) {
    _classCallCheck(this, ListEditor);

    var _this = _possibleConstructorReturn(this, (ListEditor.__proto__ || Object.getPrototypeOf(ListEditor)).call(this, props));

    _this.bindAll('handlePublishOverlayOpen');
    return _this;
  }

  _createClass(ListEditor, [{
    key: 'focusOnAddToList',
    value: function focusOnAddToList() {
      if (this._editorBody) {
        this._editorBody.getWrappedInstance().getWrappedInstance().focusOnAddToList();
      }
    }
  }, {
    key: 'handlePublishOverlayOpen',
    value: function handlePublishOverlayOpen() {
      var list = this.props.list;
      if ((0, _utilsList.listNameIsTooLong)(list) || (0, _utilsList.listDescriptionIsTooLong)(list)) {
        this._editorHeader.getWrappedInstance().focusOnError();
      } else {
        this.props.handlePublishOverlayOpen();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'cp-list-editor' },
        _react2.default.createElement(_editorToolbar2.default, {
          list: this.props.list,
          items: this.props.items,
          listScopes: this.props.listScopes,
          listLanguages: this.props.listLanguages,
          listLocales: this.props.listLocales,
          selectableListTypes: this.props.selectableListTypes,
          listHasUnsavedChanges: this.props.listHasUnsavedChanges,
          savingDraft: this.props.savingDraft,
          publishing: this.props.publishing,
          failedToSave: this.props.failedToSave,
          editingAnchorBib: this.props.editingAnchorBib,
          listPreviewURL: this.props.listPreviewURL,
          messages: this.props.messages,
          handleListPropertyChange: this.props.handleListPropertyChange,
          handleFormSubmit: this.props.handleFormSubmit,
          handleOpenAddToList: this.props.handleOpenAddToList,
          handleBackButtonClick: this.props.handleBackButtonClick,
          handleAddItemsToTopChange: this.props.handleAddItemsToTopChange,
          getOffsetForStickyToolbar: this.props.getOffsetForStickyToolbar,
          addItemsToTop: this.props.addItemsToTop,
          showPublishOverlay: this.props.showPublishOverlay,
          handlePublishOverlayOpen: this.handlePublishOverlayOpen,
          handlePublishOverlayClose: this.props.handlePublishOverlayClose }),
        _react2.default.createElement(_editorHeader2.default, {
          ref: function ref(el) {
            return _this2._editorHeader = el;
          },
          list: this.props.list,
          searchParams: this.props.searchParams,
          searchResults: this.props.searchResults,
          editingAnchorBib: this.props.editingAnchorBib,
          allowFreeText: this.props.allowFreeText,
          listNameExamples: this.props.listNameExamples,
          selectableListTypes: this.props.selectableListTypes,
          handleEditAnchorBib: this.props.handleEditAnchorBib,
          handleListPropertyChange: this.props.handleListPropertyChange,
          handleSearch: this.props.handleSearch,
          getNextPageSearchResults: this.props.getNextPageSearchResults,
          setSearchParameter: this.props.setSearchParameter,
          handleSearchParameterChange: this.props.handleSearchParameterChange,
          handleClearSearch: this.props.handleClearSearch,
          jacketCoverImgSrc: this.props.jacketCoverImgSrc,
          handleGenerateJacketCover: this.props.handleGenerateJacketCover,
          handleAnchorBibSelected: this.props.handleAnchorBibSelected }),
        _react2.default.createElement(
          'div',
          { className: 'row content-row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-12 col-md-8 col-lg-9 col-md-offset-4 col-lg-offset-3 list-content' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12' },
                _react2.default.createElement(_editorBody2.default, {
                  ref: function ref(el) {
                    return _this2._editorBody = el;
                  },
                  list: this.props.list,
                  items: this.props.items,
                  searchParams: this.props.searchParams,
                  searchResults: this.props.searchResults,
                  webItem: this.props.webItem,
                  editingAnchorBib: this.props.editingAnchorBib,
                  addToListOpen: this.props.addToListOpen,
                  showAddToList: this.props.showAddToList,
                  allowFreeText: this.props.allowFreeText,
                  keepSearchResultsOpen: this.props.keepSearchResultsOpen,
                  addItemsToTop: this.props.addItemsToTop,
                  handleListPropertyChange: this.props.handleListPropertyChange,
                  handleSearch: this.props.handleSearch,
                  handleAddBib: this.props.handleAddBib,
                  handleAddWebItem: this.props.handleAddWebItem,
                  handleRemoveItem: this.props.handleRemoveItem,
                  handleItemPropertyChange: this.props.handleItemPropertyChange,
                  handleOpenAddToList: this.props.handleOpenAddToList,
                  getNextPageSearchResults: this.props.getNextPageSearchResults,
                  setSearchParameter: this.props.setSearchParameter,
                  handleSearchParameterChange: this.props.handleSearchParameterChange,
                  handleClearSearch: this.props.handleClearSearch,
                  handleWebItemPropertyChange: this.props.handleWebItemPropertyChange,
                  handleItemDragged: this.props.handleItemDragged,
                  handleCloseAddToList: this.props.handleCloseAddToList,
                  handleItemMovedUp: this.props.handleItemMovedUp,
                  handleItemMovedDown: this.props.handleItemMovedDown,
                  handleWebURLSelected: this.props.handleWebURLSelected,
                  availabilityDetailActions: this.props.availabilityDetailActions,
                  handleAddItemsMoved: this.props.handleAddItemsMoved })
              )
            )
          )
        )
      );
    }
  }]);

  return ListEditor;
}(_baseBcReactComponent2.default);

ListEditor.propTypes = {
  list: _bcPropTypes.listShape,
  listTypes: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
  selectableListTypes: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
  listScopes: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.string),
  listLanguages: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.string),
  listLocales: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.string),
  handleSearch: _react.PropTypes.func.isRequired,
  items: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape),
  searchResults: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape),
  searchParams: _reactImmutableProptypes2.default.map,
  webItem: _reactImmutableProptypes2.default.map,
  jacketCoverImgSrc: _react.PropTypes.shape({
    localUrl: _react.PropTypes.string,
    largeCover: _react.PropTypes.string,
    mediumCover: _react.PropTypes.string,
    smallCover: _react.PropTypes.string,
    type: _react.PropTypes.string
  }),
  listHasUnsavedChanges: _react.PropTypes.bool.isRequired,
  savingDraft: _react.PropTypes.bool.isRequired,
  publishing: _react.PropTypes.bool.isRequired,
  failedToSave: _react.PropTypes.bool.isRequired,
  editingAnchorBib: _react.PropTypes.bool.isRequired,
  listPreviewURL: _react.PropTypes.string,
  addToListOpen: _react.PropTypes.bool,
  showAddToList: _react.PropTypes.bool,
  messages: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.map),
  allowFreeText: _react.PropTypes.bool.isRequired,
  listNameExamples: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
  keepSearchResultsOpen: _react.PropTypes.bool,
  addItemsToTop: _react.PropTypes.bool,
  showPublishOverlay: _react.PropTypes.bool,

  handleEditAnchorBib: _react.PropTypes.func.isRequired,
  handleAddBib: _react.PropTypes.func.isRequired,
  handleRemoveItem: _react.PropTypes.func.isRequired,
  handleItemPropertyChange: _react.PropTypes.func.isRequired,
  getNextPageSearchResults: _react.PropTypes.func.isRequired,
  handleListPropertyChange: _react.PropTypes.func.isRequired,
  handleSearchParameterChange: _react.PropTypes.func.isRequired,
  handleFormSubmit: _react.PropTypes.func.isRequired,
  handleClearSearch: _react.PropTypes.func.isRequired,
  handleWebItemPropertyChange: _react.PropTypes.func.isRequired,
  handleItemDragged: _react.PropTypes.func.isRequired,
  handleBackButtonClick: _react.PropTypes.func.isRequired,
  handleOpenAddToList: _react.PropTypes.func.isRequired,
  getOffsetForStickyToolbar: _react.PropTypes.func.isRequired,
  handleCloseAddToList: _react.PropTypes.func.isRequired,
  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
  handleAddItemsToTopChange: _react.PropTypes.func.isRequired,
  handleAddItemsMoved: _react.PropTypes.func.isRequired,
  handleItemMovedUp: _react.PropTypes.func.isRequired,
  handleItemMovedDown: _react.PropTypes.func.isRequired,
  handleWebURLSelected: _react.PropTypes.func.isRequired,
  handlePublishOverlayOpen: _react.PropTypes.func.isRequired,
  handlePublishOverlayClose: _react.PropTypes.func.isRequired,

  intl: _reactIntl.intlShape
};

exports.default = (0, _reactIntl.injectIntl)(ListEditor, { withRef: true });


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/list-editor/components/ListEditor.component.js
// module id = 1306
// module chunks = 0